module.exports = __webpack_public_path__ + "img/sakura-particle.a3d2ad56.png";